import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-white',
  accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-white',
  secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-white',
};

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            {t('home.categories')}
          </h2>
          <p className="mt-2 text-sm text-foreground-500">{t('home.categories.subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={`/category/${cat.slug}`}
              className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg border border-background-200 transition-all duration-300 cursor-pointer hover:border-transparent ${colorMap[cat.color] || colorMap.primary}`}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/80 group-hover:bg-white/20 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500 group-hover:text-inherit group-hover:opacity-80 text-center line-clamp-2">
                {cat.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}